import { gql } from "@apollo/client"

export const TOURNAMENT_CANCEL = gql`
  mutation TournamentCancel($TournamentCancelInput: TournamentCancelInput!) {
    TournamentCancel(input: $TournamentCancelInput) {
      status {
        success
        name
        detail
      }
      Tournament {
        id
        name
        urlView
        isPresential
      }
    }
  }
`

export const TOURNAMENT_DELETE = gql`
  mutation TournamentDelete($TournamentDeleteInput: TournamentDeleteInput!) {
    TournamentDelete(input: $TournamentDeleteInput) {
      status {
        success
        name
        detail
      }
    }
  }
`
